export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getToken = () => localStorage.getItem("modify_admin_token") || "";

export const authHeaders = () => ({ Authorization: `Bearer ${getToken()}` });
